export default {
    computed: {
    },
    watch: {},
    methods: {
        getDateUnixTime(dateStr) {
            if(!dateStr) return;
            let [yr, mth, day] = dateStr.split('-')
            yr = parseInt(yr)
            mth = parseInt(mth) - 1
            day = parseInt(day)
            return new Date(yr, mth, day).getTime()
        },

        addDays(unixTime, days) {
            return unixTime + days * 24 * 60 * 60 * 1000
        },

        getDateFromUnixTime(unixTime) {
            const dt = new Date(unixTime)
            return `${dt.getFullYear()}-${this.twoDigitsFormat(
                dt.getMonth() + 1
            )}-${this.twoDigitsFormat(dt.getDate())}`
        },

        getName(user) {
            return user && user.first_name + ' ' + user.last_name
        },

        twoDigitsFormat(x) {
            x = parseInt(x) || 0
            return ("0" + x).slice(-2)
        },

        onlyUnique(value, index, array) {
            return array.indexOf(value) === index;
        },


        getAssetSchedulerData(assets) {
            return assets.flatMap(
                ({
                    id,
                    asset_id,
                    next_service_date,
                    // contract_expiry_date,
                    termination_date,
                    frequency,
                    name,
                    default_engineer,
                    customer,
                    type_id,
                    type,
                    schedule_name: schedule_name = '',
                }) => {

                    if (!next_service_date) return [] // || !contract_expiry_date
                    const next_service_ut =
                        this.getDateUnixTime(next_service_date)
                    const unlimited_expiry_date = this.addDays(
                        next_service_ut,
                        365
                    )
                    const expiry_date_ut =
                        this.getDateUnixTime(termination_date) || unlimited_expiry_date

                    const current_date_ut = Date.now()
                    const ServiceDates = [] // Declare the variable outside the if block

                    let new_service_date_ut = next_service_ut;
                    while (expiry_date_ut > current_date_ut && new_service_date_ut < expiry_date_ut && ServiceDates.length < 10000) {
                        ServiceDates.push(new_service_date_ut)
                        new_service_date_ut = this.addDays(
                            new_service_date_ut,
                            frequency
                        )
                    }

                    ServiceDates.sort((a, b) => a - b)
                    const { onlyUnique } = this;

                    return ServiceDates.filter(onlyUnique).map((newDate) => ({
                        title: name,
                        start: this.getDateFromUnixTime(newDate),
                        customerName: customer && customer.name,
                        agentName: this.getName(default_engineer),
                        type_id,
                        typeName: type.name,
                        nextDate: this.getDateFromUnixTime(newDate),
                        eventId: asset_id ?? id,
                        schedule_name: schedule_name ?? '',
                    }))
                }
            )
        },
    },
}
